{
  "version": 1,
  "asset_id": "f3d208d6-1b3e-4557-9247-4634f961315b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f3d208d6-1b3e-4557-9247-4634f961315b/carage-semrush-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f3d208d6-1b3e-4557-9247-4634f961315b/carage-semrush-1280.avif",
  "original_filename": "carage-semrush-1280.avif",
  "size": 24443,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:49Z"
}
